<template>
  <div class="iframe-modal modal" v-if="isActive && iframeSrc">
    <div class="modal__overlay" @click="handleClose"></div>

    <div class="modal__modal">
      <button class="modal__close" @click="handleClose">Stäng</button>

      <div class="modal__content">
        <iframe :src="iframeSrc" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeSrc: null,
      isActive: false,
    }
  },
  methods: {
    handleClose: function() {
      document.body.classList.remove('modal--active')
      this.isActive = false
    },
  },
  created() {
    bus.$on('iframe_modal_toggle', iframeSrc => {
      document.body.classList.add('modal--active')
      this.iframeSrc = iframeSrc
      this.isActive = true
    })
  },
}
</script>
